/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2019/05/seo-talk-naturally-good/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2019/05/seo-talk-naturally-good/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2019/05/seo-talk-naturally-good/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Upcoming SEO Talk at Naturally Good Conference - How to Rank Number 1 on Google - Tribalism",
  date: "2019-05-24",
  summary: "We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. We explore How to Rank Number 1 on Google.",
  image: "/img/posts/2019-05-24-seo-talk-naturally-good/1-naturally-resize.webp",
  url: "https://www.tribalism.com.au/blog-post/2019/05/seo-talk-naturally-good",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="How to Rank Number 1 on Google - Tribalism"
        image="/img/posts/2019-05-24-seo-talk-naturally-good/1-naturally-resize.webp"
        url="https://www.tribalism.com.au/blog-post/2019/05/seo-talk-naturally-good"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. We explore How to Rank Number 1 on Google"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2019-05-24-seo-talk-naturally-good/1-naturally-resize.webp" filter="dark" >
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Upcoming SEO Talk at Naturally Good Conference
              </h1>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>

      <Footer
        
      />
    </div>
  );
}
